import { render } from "./Advantages.vue?vue&type=template&id=1921eed8"
const script = {}

import "./Advantages.vue?vue&type=style&index=0&id=1921eed8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__